<div class="card card-grey card-form">
  <ng-container *ngIf="!isLoading; else loader">
    <div *ngIf="billParams" class="bill-params-wrapper">
      <div class="left-wrapper">

        <div class="navigation">
          <div class="navigation-item-wrapper" [class.active]="isActive('main')" (click)="onTab('main')">
            <span class="navigation-item-label">Informations générales</span>
          </div>
          <div class="navigation-item-wrapper" [class.active]="isActive('tax')" (click)="onTab('tax')">
            <span class="navigation-item-label">Mentions légales</span>
          </div>
          <div class="navigation-item-wrapper" [class.active]="isActive('custom')" (click)="onTab('custom')">
            <span class="navigation-item-label">Logo & En-tête</span>
          </div>
          <div class="navigation-item-wrapper" [class.active]="isActive('custom2')" (click)="onTab('custom2')">
            <span class="navigation-item-label">Signature & Pied de page</span>
          </div>
        </div>

        <ng-container *ngIf="currentTabName === 'main'">
          <div class="form-field w-100">
            <label>Raison sociale <small>(Nom et Prénom, si vide)</small></label>
            <textarea [(ngModel)]="billParams.socialReason"
                      class="form-control"
                      style="border-radius: 0.25rem !important;"
                      placeholder="Nom Prénom ou Appelation publique"
                      type="text">
            </textarea>
          </div>

          <div class="form-field">
            <label>Adresse de facturation <small>(Adresse du compte, si vide)</small></label>
            <textarea [(ngModel)]="billParams.address"
                      class="form-control"
                      style="border-radius: 0.25rem !important;"
                      placeholder="Adresse..."
                      type="text">
            </textarea>
          </div>

          <div class="form-field">
            <label>Code postal <small>(C.P. du compte, si vide)</small></label>
            <input [(ngModel)]="billParams.zip" class="form-control" placeholder="Code postal" type="text">
          </div>

          <div class="form-field">
            <label>Ville <small>(Ville du compte, si vide)</small></label>
            <input [(ngModel)]="billParams.city" class="form-control" placeholder="Ville" type="text">
          </div>

          <div class="form-field mb-1em">
            <label>Pays <small>(Pays du compte, si vide)</small></label>
            <select [(ngModel)]="billParams.country" aria-label="Sélectionner un pays" class="form-control form-select">
              <option value="" selected disabled>Sélectionner un pays</option>
              <option *ngFor="let country of countries" [value]="country.alpha2">{{ country.country_name }}</option>
            </select>
            <div class="invalid-feedback">
              Veuillez sélectionner un pays.
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="currentTabName === 'tax'">
          <div class="d-flex">
            <div class="form-field min-width">
              <label>Type de matricule <small>(facultatif)</small></label>
              <select [(ngModel)]="typeRegistrationNumber"
                      class="form-control custom-select">
                <option [ngValue]="undefined" selected disabled>Choisir un type...</option>
                <option [ngValue]="RPPS">RPPS</option>
                <option [ngValue]="ADELI">ADELI</option>
                <option [ngValue]="INAMI">INAMI</option>
                <option [ngValue]="OTHER">Autre...</option>
              </select>
            </div>

            <div *ngIf="typeRegistrationNumber === '_'" class="form-field min-width ml10px">
              <label>Nom autre type</label>
              <input [(ngModel)]="valueTypeRegistrationNumber"
                     class="form-control"
                     placeholder="Nom de type..."
                     type="text">
            </div>

            <div class="form-field ml10px w-100">
              <label>Matricule <small>(facultatif)</small></label>
              <input [(ngModel)]="adeliNumber"
                     class="form-control"
                     placeholder="RPPS, ADELI, INAMI..."
                     type="text">
            </div>
          </div>

          <div class="form-field w-100">
            <label>N° Siret <small>(facultatif)</small></label>
            <input [(ngModel)]="billParams.registrationNumber"
                   class="form-control"
                   placeholder="Par ex. : 9013245678913"
                   type="text">
          </div>

          <div class="form-field d-flex flex-column mt16px">
            <label>Taxe sur la valeur ajoutée (TVA)</label>
            <div>
              <input class="form-check-input mr5px"
                     [(ngModel)]="billParams.tax"
                     (ngModelChange)="onChangeBillTax($event)"
                     id="with-tax-radio"
                     name="tax"
                     type="radio"
                     value="with">
              <label class="form-check-label call-to-action-md" for="with-tax-radio">Je facture la TVA</label>
            </div>
            <div>
              <input class="form-check-input mr5px"
                     [(ngModel)]="billParams.tax"
                     (ngModelChange)="onChangeBillTax($event)"
                     id="without-tax-radio"
                     name="tax"
                     type="radio"
                     value="without">
              <label class="form-check-label call-to-action-md" for="without-tax-radio">Je ne facture pas de TVA</label>
            </div>
          </div>

          <div *ngIf="withTax" class="form-field">
            <label>N° de TVA intracommunautaire <small>(laisser vide, si en cours d'attribution)</small></label>
            <input [(ngModel)]="billParams.taxNumber"
                   [class.is-invalid]="taxNumberInvalid"
                   class="form-control"
                   placeholder="Par ex. : FR0123456789"
                   type="text">
            <div class="invalid-feedback">
              Veuillez entrer un n° de TVA valide.
            </div>
          </div>

          <div *ngIf="withTax" class="form-field">
            <label>Taux de TVA en %</label>
            <input [(ngModel)]="billParams.taxRate"
                   [class.is-invalid]="taxRateInvalid"
                   class="form-control"
                   placeholder="Par ex. : 20%"
                   type="number">
            <div class="invalid-feedback">
              Veuillez entrer un taux de TVA valide.
            </div>
          </div>

          <div *ngIf="!withTax" class="form-field">
            <label class="form-check-label">
              La mention "TVA non applicable selon l'article 261 du CGI" sera ajoutée à la facture.
            </label>
          </div>

          <div class="mt16px">
            <label>Faire apparaître la mention suivante <small>(facultatif)</small></label>
            <div class="d-flex mb10px">
              <input class="form-check-input mr5px"
                     [(ngModel)]="billParams.late"
                     id="late"
                     name="late"
                     type="checkbox">
              <label class="form-check-label" for="late">Pénalité en cas de retard : 3 fois le taux de l’intérêt légal
                annuel actuel. Indemnité forfaitaire de 40 € pour frais de recouvrement en cas de retard.</label>
            </div>
          </div>

          <div class="mt16px">
            <label>Faire apparaître les mentions suivantes en pied de page <small>(facultatif)</small></label>
            <div class="d-flex mb10px">
              <input class="form-check-input mr5px"
                     [(ngModel)]="billParams.aga"
                     id="aga"
                     name="aga"
                     type="checkbox">
              <label class="form-check-label" for="aga">Membre d’une association agréée par l’administration fiscale
                acceptant à ce titre le règlement des honoraires par carte bancaire ou par chèques libellés à son
                nom.</label>
            </div>
            <div>
              <input class="form-check-input mr5px"
                     [(ngModel)]="billParams.rcs"
                     id="rcs"
                     name="rcs"
                     type="checkbox">
              <label class="form-check-label" for="rcs">Dispensé d’immatriculation au registre du commerce et des
                sociétés (RCS) et au répertoire des métiers (RM).</label>
            </div>
          </div>


        </ng-container>

        <ng-container *ngIf="currentTabName === 'custom'">
          <div class="logo-wrapper">
            <msd-bill-picture (onChoose)="imageInput.click()"
                              [isLoading]="isLogoLoading"
                              [placeHolder]="'Cliquer pour ajouter un logo'"
                              [url]="billParams.logo?.url">
            </msd-bill-picture>
            <div class="logo-button">
              <input #imageInput hidden type="file" accept="image/*" (change)="logoSelected($event)">
              <div *ngIf="billParams.logo && !isLogoLoading" class="w-100">
                <div class="form-field d-flex flex-column mb10px">
                  <label>Position du logo</label>
                  <div>
                    <input class="form-check-input mr5px"
                           [(ngModel)]="billParams.logoPosition"
                           id="logo-left-radio"
                           name="logoPosition"
                           type="radio"
                           value="left">
                    <label class="form-check-label call-to-action-md" for="logo-left-radio">À gauche</label>
                    &nbsp;
                    <input class="form-check-input mr5px"
                           [(ngModel)]="billParams.logoPosition"
                           id="logo-center-radio"
                           name="logoPosition"
                           type="radio"
                           value="center">
                    <label class="form-check-label call-to-action-md" for="logo-center-radio">Au centre</label>

                    <input class="form-check-input mr5px ml10px"
                           [(ngModel)]="billParams.logoPosition"
                           id="logo-right-radio"
                           name="logoPosition"
                           type="radio"
                           value="right">
                    <label class="form-check-label call-to-action-md" for="logo-right-radio">À droite</label>
                  </div>
                </div>

                <div class="form-field d-flex flex-column mb10px">
                  <label>Taille du logo</label>
                  <div>
                    <input class="form-check-input mr5px"
                           [(ngModel)]="billParams.logoSize"
                           id="logo-small-radio"
                           name="logoSize"
                           type="radio"
                           value="small">
                    <label class="form-check-label call-to-action-md" for="logo-small-radio">Petit</label>
                    &nbsp;
                    <input class="form-check-input mr5px ml10px"
                           [(ngModel)]="billParams.logoSize"
                           id="logo-medium-radio"
                           name="logoSize"
                           type="radio"
                           value="medium">
                    <label class="form-check-label call-to-action-md" for="logo-medium-radio">Moyen</label>

                    <input class="form-check-input mr5px ml10px"
                           [(ngModel)]="billParams.logoSize"
                           id="logo-large-radio"
                           name="logoSize"
                           type="radio"
                           value="large">
                    <label class="form-check-label call-to-action-md" for="logo-large-radio">Grand</label>
                  </div>
                </div>

                <div class="d-inline-flex">
                  <button (click)="imageInput.click()"
                          [disabled]="isLogoLoading"
                          class="btn btn-gradient desktop mt8px mr10px"
                          type="button">
                    Changer
                    <i i-bs name="plus" width="20" height="20"></i>
                  </button>
                  <button (click)="deleteLogoPicture()"
                          [disabled]="isLogoLoading"
                          class="btn btn-outline btn-outline-primary desktop mt8px"
                          type="button">
                    Supprimer
                    <i i-bs name="x" width="20" height="20"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="form-field">
            <label>Téléphone <small>(facultatif)</small></label>
            <input [(ngModel)]="billParams.phoneNumber" class="form-control" placeholder="+33..." type="tel">
          </div>

          <div class="form-field">
            <label>Adresse Email <small>(facultatif)</small></label>
            <input [(ngModel)]="billParams.email" class="form-control" placeholder="Email" type="email">
          </div>
        </ng-container>

        <ng-container *ngIf="currentTabName === 'custom2'">
          <div class="sign-wrapper">
            <div class="sign-button">
              <input #imageInput hidden type="file" accept="image/*" (change)="signSelected($event)">
              <div  class="w-100">
                <div class="form-field d-flex flex-column mb10px">
                  <label>Taille de la signature</label>
                  <div>
                    <input class="form-check-input mr5px"
                           [(ngModel)]="billParams.signSize"
                           id="sign-small-radio"
                           name="signSize"
                           type="radio"
                           value="small">
                    <label class="form-check-label call-to-action-md" for="sign-small-radio">Petite</label>
                    &nbsp;
                    <input class="form-check-input mr5px ml10px"
                           [(ngModel)]="billParams.signSize"
                           id="sign-medium-radio"
                           name="signSize"
                           type="radio"
                           value="medium">
                    <label class="form-check-label call-to-action-md" for="sign-medium-radio">Moyenne</label>

                    <input class="form-check-input mr5px ml10px"
                           [(ngModel)]="billParams.signSize"
                           id="sign-large-radio"
                           name="signSize"
                           type="radio"
                           value="large">
                    <label class="form-check-label call-to-action-md" for="sign-large-radio">Grande</label>
                  </div>
                </div>
                <div *ngIf="billParams.sign && !isSignLoading" class="d-inline-flex">
                  <button (click)="imageInput.click()"
                          [disabled]="isSignLoading"
                          class="btn btn-gradient desktop mt8px mr10px"
                          type="button">
                    Changer
                    <i i-bs name="plus" width="20" height="20"></i>
                  </button>
                  <button (click)="deleteSignPicture()"
                          [disabled]="isSignLoading"
                          class="btn btn-outline btn-outline-primary desktop mt8px"
                          type="button">
                    Supprimer
                    <i i-bs name="x" width="20" height="20"></i>
                  </button>
                </div>
              </div>
            </div>
            <msd-bill-picture (onChoose)="imageInput.click()"
                              [isLoading]="isSignLoading"
                              [placeHolder]="'Cliquer pour ajouter une signature'"
                              [url]="billParams.sign?.url">
            </msd-bill-picture>
            <input #imageInput hidden type="file" accept="image/*" (change)="signSelected($event)">
          </div>

          <div class="form-field w-100">
            <label>Mention en pied de page <small>(facultatif)</small></label>
            <input [(ngModel)]="billParams.footer" type="text" class="form-control"
                   placeholder="Mention légale, autres informations...">
          </div>
        </ng-container>
      </div>

      <div class="right-wrapper">
        <div class="preview" (click)="openPreview()">
          <ng-container *ngIf="!isPreviewLoading; else loaderPreview">
            <pdf-viewer *ngIf="billParams.previewUrl"
                        [src]="billParams.previewUrl"
                        [render-text]="true"
                        [original-size]="false"
                        [class.hidden]="isPreviewLoading"
                        class="pdf-viewer">
            </pdf-viewer>
          </ng-container>
          <ng-template #loaderPreview>
            <div class="pdf-loader">
              <div class="d-flex w-100 flex-nowrap justify-content-center align-self-center">
                <span class="spinner-grow spinner-grow-sm mt2px" role="status" aria-hidden="true"></span>
                <span class="ml5px nowrap"><small>Chargement de la prévisualisation</small></span>
              </div>
            </div>
          </ng-template>
        </div>
        <div class="caption">
          <small>Prévisualisation de la facture</small>
        </div>
      </div>
    </div>

    <button type="button" class="btn btn-primary btn-gradient" (click)="saveBillParams()">
      <ng-container *ngIf="isSaving; else saveButton">
        <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
        <span class="visually-hidden">Chargement...</span>
      </ng-container>
      <ng-template #saveButton>
        Sauvegarder
        <i i-bs name="check" width="20" height="20"></i>
      </ng-template>
    </button>
  </ng-container>
  <ng-template #loader>
    <ngx-inner-loading
      class="flex-center"
      [loading]="isLoading"
      [loadingDescription]="'Chargement...'"
    >
    </ngx-inner-loading>
  </ng-template>
</div>
